var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import WindowReadonlyContext from '../../context/window-readonly-context';
import WindowStateContext from '../../context/window-state-context';
import { getGeometryStyle } from '../../helpers/styles';
import { isTrue } from '../../helpers/utils';
import useAnimatedTextItem from '../../hooks/useAnimatedTextItem';
var StyledTextArea = styled.textarea.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  background: ", ";\n  outline: ", ";\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  cursor: ", ";\n"], ["\n  ", "\n  color: ",
    ";\n  background: ",
    ";\n  outline: ", ";\n  border: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ",
    ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  padding-left: ", ";\n  padding-right: ", ";\n  cursor: ", ";\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme, fontColor = _a.fontColor;
    return fontColor !== null && fontColor !== void 0 ? fontColor : windowTheme.textArea.color;
}, function (_a) {
    var windowTheme = _a.windowTheme, backgroundColor = _a.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : windowTheme.textArea.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textArea.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textArea.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textArea.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textArea.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textArea.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textArea.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textArea.paddingLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.textArea.paddingRight;
}, function (_a) {
    var readOnly = _a.readOnly;
    return (readOnly ? 'not-allowed' : 'auto');
});
var TextArea = function (props) {
    var identifier = props.identifier, attributes = props.attributes, form = props.form, _a = props.type, type = _a === void 0 ? 'text' : _a, onChange = props.onChange, children = props.children, windowId = props.windowId, restProps = __rest(props, ["identifier", "attributes", "form", "type", "onChange", "children", "windowId"]);
    var enabled = attributes.enabled, charLimit = attributes.charLimit, readOnly = attributes.readOnly, geometry = attributes.geometry, otherAttributes = __rest(attributes, ["enabled", "charLimit", "readOnly", "geometry"]);
    var disabled = enabled === 'false';
    var overWriteReadOnly = useContext(WindowReadonlyContext);
    var hookProps = useAnimatedTextItem(identifier);
    var stateFromEnv = useContext(WindowStateContext);
    var valuesFromEnv = stateFromEnv.fields;
    var fontColor = valuesFromEnv[identifier + "_fontColor"];
    var backgroundColor = valuesFromEnv[identifier + "_backgroundColor"];
    return (React.createElement(StyledTextArea, __assign({ maxLength: charLimit, type: type, id: identifier, geometry: geometry }, restProps, otherAttributes, { disabled: !overWriteReadOnly && disabled, readOnly: !overWriteReadOnly && isTrue(readOnly) }, hookProps, { fontColor: fontColor, backgroundColor: backgroundColor })));
};
export default TextArea;
var templateObject_1;
//# sourceMappingURL=index.js.map